import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../Utils/thunkHelpers"
import {
  confirmCreditAutomationAccess as confirmCreditAutomationAccessApi,
  getCreditAutomation as getCreditAutomationApi,
  requestCreditAutomation as requestCreditAutomationApi,
  turnOffCreditAutomation as turnOffCreditAutomationApi
} from "../services"
import { CREDIT_AUTOMATION_SLICE_NAME } from "./creditAutomation.constants"

export const getCreditAutomation = createAsyncThunk(
  `${CREDIT_AUTOMATION_SLICE_NAME}/get`,
  async (_, { dispatch, rejectWithValue }) => {
    const response = await getCreditAutomationApi()
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

// CHA1-3086: 201 means a fresh request went through - the body is the new account state, apply it
// directly. 200 means the merchant already has a request in flight - the body is just a `detail`
// notice, so re-fetch to pick up the (unchanged) real state instead of trusting this response's shape.
export const requestCreditAutomation = createAsyncThunk(
  `${CREDIT_AUTOMATION_SLICE_NAME}/request`,
  async (_, { dispatch, rejectWithValue }) => {
    const response = await requestCreditAutomationApi()
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    if (response.status === 200) {
      dispatch(getCreditAutomation())
      return { alreadyRequested: true, detail: response.data?.detail }
    }
    return { alreadyRequested: false, data: response.data }
  }
)

// Confirming access doesn't activate the row - the response is just an acknowledgement, the real
// state (`merchant_confirmed_at`) is only reflected after a re-fetch.
export const confirmCreditAutomationAccess = createAsyncThunk(
  `${CREDIT_AUTOMATION_SLICE_NAME}/confirm_access`,
  async (serviceName, { dispatch, rejectWithValue }) => {
    const response = await confirmCreditAutomationAccessApi(serviceName)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    dispatch(getCreditAutomation())
    return response.data
  }
)

// CHA1-3198: the response is just a `detail` notice, not the new account state - re-fetch to pick
// up the real state (all processors Disabled, banner null, can_request still true).
export const turnOffCreditAutomation = createAsyncThunk(
  `${CREDIT_AUTOMATION_SLICE_NAME}/turn_off`,
  async (_, { dispatch, rejectWithValue }) => {
    const response = await turnOffCreditAutomationApi()
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    dispatch(getCreditAutomation())
    return response.data
  }
)
